import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { FollowList } from '../FollowList';
import { ListAvatarsLayout } from '../Lists/ListAvatarsLayout';
import { ListAvatars } from '../Lists/ListAvatars';

export function UserNetwork(props) {
  const {
    useravatarId,
    user,
    children,
    startState = 'followings',
    mode = 'hd'
  } = { ...props };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [list, setList] = useState(startState);
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;



  const [listInner, setListInner] = useState([]);

  useEffect(() => {
    if (useravatarId === context.me.user.token) {

    } else {
      context.x.fetchUser(user.token, (userData) => {
        setListInner(userData ? userData : [])
      }, true)
    }
  }, [useravatarId])

  useEffect(() => {
    if (useravatarId === context.me.user.token) {
      setListInner({
        followers: context.followers,
        followings: context.followings
      })
    }
  }, [context.followers, context.followings])

  useEffect(() => {
    console.log('listInner = ', listInner);
  }, [listInner])




  const drawSelector = () => (<div className="m_b_toggles">
    <div className="ui_radiogroup_h">

      <div className={list === 'followers' ? `ui_radio_h active` : `ui_radio_h`}
        onClick={() => setList('followers')}
      >
        <b>
          {$ui('pop_followers')}
        </b>
        <div className="x_choose_menu_counter">{user.aggr.followers_count}</div>
      </div><div className={list === 'followings' ? `ui_radio_h active` : `ui_radio_h`}
        onClick={() => setList('followings')}
      >
        <b>
          {$ui('pop_following')}
        </b>
        <div className="x_choose_menu_counter">{user.aggr.followings_count}</div>
      </div>
    </div>
  </div>)


  return (
    <>

      {/* 

<ListAvatarsLayout icon=''
        className='followers'
        title={$ui('pop_followers')}
        quantity={user.aggr.followers_count}
        listId='followers'
      >
        <ListAvatars
          listId='followers'
          array={listInner['followers']}
          customGridClass='x_choose x_choose--v x_choose--followers'
          // fullList={true}
          // paginate={5}
        />
      </ListAvatarsLayout>

<ListAvatarsLayout icon=''
        className='followers'
        title={$ui('pop_following')}
        quantity={user.aggr.followings_count}
        listId='followers'
      >
        <ListAvatars
          listId='followers'
          array={listInner['followings']}
          customGridClass='x_choose x_choose--v x_choose--followers'
          // fullList={true}
          // paginate={5}
        />
      </ListAvatarsLayout> */}


      {drawSelector()}

      <FollowList
        style={{
          display: list === 'followers' ? 'flex' : 'none'
        }}
        count={user.aggr.followers_count}
        token={useravatarId}
        listId={'followers'}
        array={listInner['followers']}
        mode={mode}
      >
        {/* {drawSelector()} */}
      </FollowList>



      <FollowList
        style={{
          display: list === 'followings' ? 'flex' : 'none'
        }}
        count={user.aggr.followings_count}
        token={useravatarId}
        listId={'followings'}
        array={listInner['followings']}
        mode={mode}
      >
        {/* {drawSelector()} */}
      </FollowList>




    </>
  )
}